import { TintingIntensity } from '@order/steps/types'

export const intensityOpacity: Record<TintingIntensity, number[]> = {
  full: [1],
  '85': [0.9, 0.8],
  '75': [0.8, 0.7],
  '75-35': [0.8, 0.3],
  '10': [0.2, 0.1],
}

export const defaultBackColors = [
  {
    color: '#ffffff',
    opacity: 100,
  },
]
